import { AgreementRoutes } from 'app/features/agreement';
import { CustomerRoutes } from 'app/features/customer';
import { InboxRoutes } from 'app/features/inbox';
import { ListTypeRoutes } from 'app/features/listtype/listtype.routes';
import { UserRoutes } from 'app/features/user';

export const APP_ROUTES = {
    Inbox: 'inbox',
    InboxList: `inbox/${InboxRoutes.InboxList}`,
    Customer: 'customer',
    CustomerList: `customer/${CustomerRoutes.CustomerList}`,
    Counterpart: 'counterpart',
    CounterpartList: `counterpart/${CustomerRoutes.CustomerList}`,
    Agreement: `agreement`,
    AgreementList: `agreement/${AgreementRoutes.AgreementList}`,
    InventoryList: `agreement/${AgreementRoutes.InventoryList}`,
    ListType: 'listtype',
    ListTypeList: `listtype/${ListTypeRoutes.ListTypeList}`,
    Calendar: `calendar`,
    Login: 'login',
    Root: '',
    User: 'user',
    UserList: `user/${UserRoutes.UserList}`,
    UserProfile: `user/${UserRoutes.UserProfile}`,
    Dashboard: 'dashboard'
};
